<template>
  <div class="account">
    <msp-app-bar title="Consensi"></msp-app-bar>
    <v-container v-if="utente">
      <v-row dense
          v-for="field in fields"
          :key="field.key"
        >
            <v-col
          cols="12"
          sm="6"
            >
            <v-switch
                v-model="utente[field.key]"
                :label="field.label"
                true-value="S"
                false-value="N"
                @change="updateField(field)"
            ></v-switch>
        </v-col>
        <template v-if="utente[field.key]==='S'">
            <v-col
                v-for="option in field.options"
                :key="option"
                cols="12"
                sm="6"
            >
                <template v-if="option==='orario'">
                    <MspSelezioneOrarioFuso 
                        :utente_id = "utente.id"
                    />
                </template>
            </v-col>
        </template>
        </v-row>

    </v-container>
</div>

</template>

<script type="module">
import mspAppBar from "@components/MspAppBar.vue";
import env from "@mixins/environment.js"
import _api from "@mixins/api.js";
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import MspSelezioneOrarioFuso from "@components/MspSelezioneOrarioFuso.vue";

const component = {
  mixins: [
    env,
    allenamentoCalcoli,
  ],
  components: {
    mspAppBar,
    MspSelezioneOrarioFuso,

  },
  data () {
    return {
        maxDate: null,
        minDate: null,
        utente: null,
        fields: [
            {
                "key": "flg_invioEmailAllenamento",
                "label": "Ricezione email quotidiana dell'allenamento del giorno",
                "options": ['orario'],
            }, 
            {
                "key": "flg_invioReportPostAllenamento",
                "label": "Ricezione email del report post allenamento",
                "options": [],
            }, 
            {
                "key": "flg_invioEmailAggiornamenti",
                "label": "Ricezione email relative a aggiornamenti software e comunicazioni di servizio",
                "options": [],
            }, 
             
        ],
    }
  },
  mounted () {
    this.init();

  },
  watch: {
    },
  computed: {
  },
  methods: {
      init: function () {
        this.loadConsensi().then(
          (result)=>{
            if (result.success) {
              this.utente = {...result.data};
            }
          }
        );

      },
    updateField: function (field) {
            let data = {
                [field.key]: this.utente[field.key],
            }
            this.updateConsensi(data);
    },

    updateConsensi: function (data) {
        let url = this.api_base_url+"/api/v2/utente.php";//+params;
        return new Promise((resolve,reject)=>{
            _api(url, "PUT", data)
                .then((result)=>{
                    if (result.success) {
                        resolve(result);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                });
        });
    },

    loadConsensi: function () {
        let url = this.api_base_url+"/api/v2/utente.php";//+params;

        return new Promise((resolve,reject)=>{
            _api(url, "GET")
                .then((result)=>{
                    if (result.success) {
                        resolve(result);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                });
        });
    },

  },
}
export default component
</script>
<style lang="scss">
.account {
}
</style>
